import '../style/input-number-DBBzJ6tm.css'
import { defineComponent as fe, useCssVars as ve, unref as i, useModel as be, useSlots as ye, toRef as he, ref as g, useAttrs as xe, computed as u, watch as R, openBlock as p, createElementBlock as C, normalizeClass as we, createElementVNode as V, renderSlot as T, createCommentVNode as c, withDirectives as ge, mergeProps as Ve, toHandlers as _e, withKeys as A, withModifiers as _, vModelText as $e, createBlock as S, toDisplayString as H, withCtx as E, createVNode as N, createTextVNode as j } from "vue";
import { Decimal as q } from "decimal.js";
import { throttle as ke } from "lodash-es";
import { min as Be, max as G, add as Ce, minus as Se, divide as Ee, roundDown as J, roundUp as Ne, multiply as ze, getDecimalPlaces as Q, fixedDecimal as De, isExp as Ie, round as Me } from "x-utils";
import { Button as Y } from "./button.js";
import Oe from "./dropdown.js";
import Pe from "./icon.js";
import { Select as Re } from "./select.js";
import Te from "./spinner.js";
import { UPDATE_MODEL_VALUE as Ae, INPUT_EVENT as Ue, FOCUS_EVENT as Ke, BLUR_EVENT as Fe, CHANGE_EVENT as Le } from "./constant/events.js";
import "@vueuse/core";
import { useFormItem as We } from "./hooks/useFormItem.js";
import { useInputEvent as He } from "./hooks/useInputEvent.js";
import { useI18n as je } from "./hooks/useLocale.js";
import "./hooks/useGlobalDark.js";
import "./layout/model/Model.js";
import "./layout/DockLocation.js";
import "./layout/Orientation.js";
import "./layout/model/TabNode.js";
import "./layout/model/TabSetNode.js";
import "./layout/model/BorderNode.js";
import { useInputClass as Ge } from "./hooks/useInputClass.js";
import { useInputSize as Ye } from "./hooks/useInputSize.js";
import qe from "./internalComponents/CrossIcon.js";
import Je from "./internalComponents/InputInfoIcon.js";
const Qe = (o) => o == null || o === "" || o === !1 || isNaN(o), Xe = (o, m) => {
  const { min: a, max: n, allowNegative: r } = m;
  let l = o;
  return n !== void 0 && (l = `${Be(n, l)}`), a !== void 0 && (l = `${G(a, l)}`), r || (l = `${G("0", l)}`), l;
}, Ze = (o, m) => {
  const { step: a, multiplesOfStep: n } = m;
  let r = o;
  if (a) {
    const l = +a, d = Math.abs(l), v = l > 0;
    if (r = v ? Ce(o, d) : Se(o, d), n) {
      const $ = Ee(r, d), z = v ? J($, 0) : Ne($, 0);
      r = ze(z, d);
    }
  }
  return r;
}, et = (o, m) => {
  const a = parseInt(m.precision);
  let n = o;
  const r = Q(o, { trailing: !0 });
  return a >= 0 && r > a && (n = De(o, a, { roundDown: !0 })), n = new q(n).toString(), n;
}, tt = (o) => Qe(o) ? "" : Ie(o) ? Me({ value: o, precision: void 0, options: { fixed: !1 } }) : o, nt = {
  key: 0,
  class: "e-input-number__prefix"
}, ot = ["id", "aria-label", "placeholder", "disabled", "min", "max"], st = {
  key: 3,
  class: "e-input-number__suffix"
}, it = ["onKeydown"], lt = { class: "p-8" }, rt = { class: "text-caption1" }, at = {
  class: "flex justify-between mt-8",
  style: { "min-width": "220px" }
}, Ot = /* @__PURE__ */ fe({
  name: "e-input-number",
  __name: "input-number",
  props: {
    modelValue: {},
    disabled: { type: Boolean },
    placeholder: {},
    size: {},
    loading: { type: Boolean },
    isError: { type: Boolean, default: void 0 },
    precision: {},
    max: {},
    min: { default: "0" },
    showMaxButton: { type: Boolean },
    maxButtonText: {},
    hasCtrl: { type: Boolean },
    clearable: { type: Boolean },
    keepWithinPrecision: { type: Boolean, default: !0 },
    allowNegative: { type: Boolean, default: !1 },
    multiplesOfStep: { type: Boolean },
    alignRight: { type: Boolean },
    stepOptions: {},
    decimalConfig: { default: () => ({
      toExpNeg: -20
    }) },
    limitRange: { type: Boolean, default: !0 }
  },
  emits: [
    Ae,
    Ue,
    Ke,
    Fe,
    Le,
    // It's only for prevent event bubble and avoid `v-bind=$attrs` with onChange event.
    "step-click",
    "keydown",
    "wheel"
  ],
  setup(o, { expose: m, emit: a }) {
    ve((t) => ({
      "3b01633a": i(z)
    }));
    const n = o, r = be(n, "modelValue", { local: !0 }), l = ye(), { t: d } = je(), { formItem: v, formSize: $ } = We(), { height: z, actualSize: U } = Ye({
      formSize: $,
      propSize: he(n, "size")
    }), D = a, b = g(n.modelValue), k = g("0"), f = g(!1), I = g(!1), M = g(), K = xe(), X = ["class", "style", "type", "value", "placeholder", "disabled"], y = u(() => Math.abs(+k.value)), Z = u(() => n.clearable && !n.disabled && b.value !== "" ? f.value || I.value : !1), O = u(() => (n.stepOptions ?? []).map((e) => ({
      text: `${e}`,
      value: e
    }))), ee = u(() => {
      const t = {};
      for (const e in K)
        X.includes(e) || (t[e] = K[e]);
      return t;
    }), te = u(() => n.max !== void 0 && n.showMaxButton === !0), F = u(() => n.isError ?? ae.value), ne = u(() => {
      const t = ["e", "E", "+", "ArrowUp", "ArrowDown"];
      return n.allowNegative || t.push("-"), Number(n.precision) === 0 && t.push("."), t;
    }), oe = u(() => ({
      size: U.value,
      disabled: n.disabled,
      error: F.value,
      append: !!l.append,
      focus: f.value,
      hasCtrl: n.hasCtrl,
      alignRight: n.alignRight
    })), { inputClass: se } = Ge("input-number", oe);
    R(O, (t) => {
      t.length > 0 && (k.value = t[0].value);
    }, { immediate: !0 }), R(() => n.decimalConfig, (t) => {
      q.set(t);
    }, { immediate: !0 });
    const {
      handleInput: ie,
      handleBlur: le,
      handleFocus: re,
      isFormItemError: ae
    } = He(D), ue = (t, e) => {
      const { precision: s, keepWithinPrecision: B } = n;
      if (B && s !== void 0) {
        const P = t.target;
        if (e !== "" && +Q(e, { trailing: !0 }) > +s) {
          const ce = `${J(e, +s)}`;
          return P.value = ce, t.preventDefault(), !1;
        }
      }
      return !0;
    }, pe = (t) => {
      if (t.stopPropagation(), ne.value.includes(t.key))
        return t.preventDefault();
    }, h = (t) => {
      let e = t;
      return e = tt(t), e !== "" && (n.limitRange && (e = Xe(e, n)), e = et(e, n)), r.value = e, e;
    }, x = () => {
      b.value = r.value;
    }, me = u(() => ({
      input: (t) => {
        const { value: e } = t.target;
        ue(t, e) && (r.value = e, ie(t));
      },
      focus: re,
      blur: (t) => {
        h(b.value), x(), le(t);
      },
      keydown: pe
    })), w = (t) => {
      if (!n.hasCtrl) return;
      const e = Ze(r.value, {
        step: t,
        min: n.min,
        max: n.max,
        precision: n.precision,
        multiplesOfStep: n.multiplesOfStep
      });
      D("step-click", h(e)), x();
    }, L = ke(function(t) {
      const e = y.value;
      if (!f.value || !n.hasCtrl || !e) return;
      const { deltaY: s } = t;
      if (s === 0) return;
      const B = s > 0 ? "up" : "down", P = `${B === "up" ? e : -1 * e}`;
      w(P), D("wheel", B, t);
    }, 200), W = () => {
      n.disabled || n.max !== void 0 && (h(`${n.max}`), x());
    };
    R(() => n.modelValue, (t) => {
      f.value || (h(t), x());
    }, { immediate: !0 });
    function de() {
      h(""), x();
    }
    return m({
      inputRef: M
    }), (t, e) => (p(), C("div", {
      class: we(i(se))
    }, [
      V("div", {
        tabindex: "-1",
        class: "e-input-number__wrapper",
        onMouseenter: e[9] || (e[9] = (s) => I.value = !0),
        onMouseleave: e[10] || (e[10] = (s) => I.value = !1),
        onClick: e[11] || (e[11] = (s) => M.value?.focus())
      }, [
        i(l).prefix ? (p(), C("div", nt, [
          T(t.$slots, "prefix")
        ])) : c("", !0),
        ge(V("input", Ve({
          id: i(v).formItemId,
          ref_key: "inputRef",
          ref: M,
          "onUpdate:modelValue": e[0] || (e[0] = (s) => b.value = s),
          "aria-label": i(v).label,
          class: "e-input-number__inner",
          autocomplete: "off",
          type: "number",
          placeholder: t.placeholder,
          disabled: t.disabled,
          min: t.min,
          max: t.max,
          step: "any"
        }, ee.value, _e(me.value, !0), {
          onFocus: e[1] || (e[1] = (s) => f.value = !0),
          onBlur: e[2] || (e[2] = (s) => f.value = !1),
          onKeydown: [
            e[3] || (e[3] = A(_((s) => w(`${y.value}`), ["prevent"]), ["up"])),
            e[4] || (e[4] = A(_((s) => w(`${-1 * y.value}`), ["prevent"]), ["down"]))
          ],
          onWheel: e[5] || (e[5] = _(
            //@ts-ignore
            (...s) => i(L) && i(L)(...s),
            ["prevent"]
          ))
        }), null, 16, ot), [
          [$e, b.value]
        ]),
        T(t.$slots, "default"),
        Z.value ? (p(), S(qe, {
          key: 1,
          class: "e-input-number__icon",
          size: i(U),
          onClick: _(de, ["stop"])
        }, null, 8, ["size"])) : c("", !0),
        t.loading ? (p(), S(i(Te), {
          key: 2,
          color: "--text-primary",
          size: "24",
          class: "e-input-number__icon"
        })) : c("", !0),
        i(l).suffix ? (p(), C("div", st, [
          T(t.$slots, "suffix")
        ])) : c("", !0),
        te.value ? (p(), C("div", {
          key: 4,
          role: "button",
          tabindex: "0",
          class: "e-input-number__max",
          onClick: W,
          onKeydown: A(_(W, ["stop", "prevent"]), ["space", "enter"])
        }, H(t.maxButtonText ?? i(d)("inputNumber.max")), 41, it)) : c("", !0),
        F.value ? (p(), S(Je, {
          key: 5,
          "is-error": "",
          class: "e-input-number__icon e-input-number__error-icon"
        })) : c("", !0),
        t.hasCtrl && O.value.length > 0 ? (p(), S(i(Oe), {
          key: 6,
          disabled: t.disabled,
          class: "e-input-number__step-btn"
        }, {
          content: E(() => [
            V("div", lt, [
              V("div", rt, H(i(d)("inputNumber.adjustStep")), 1),
              V("div", at, [
                N(i(Re), {
                  modelValue: k.value,
                  "onUpdate:modelValue": e[6] || (e[6] = (s) => k.value = s),
                  options: O.value,
                  size: "sm",
                  "is-error": !1,
                  class: "flex-1"
                }, null, 8, ["modelValue", "options"]),
                N(i(Y), {
                  "color-scheme": "plain",
                  size: "sm",
                  class: "ml-8",
                  onClick: e[7] || (e[7] = (s) => w(`${-1 * y.value}`))
                }, {
                  default: E(() => [
                    j(" - ")
                  ]),
                  _: 1
                }),
                N(i(Y), {
                  "color-scheme": "plain",
                  size: "sm",
                  class: "ml-8",
                  onClick: e[8] || (e[8] = (s) => w(`${y.value}`))
                }, {
                  default: E(() => [
                    j(" + ")
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          default: E(() => [
            N(i(Pe), {
              icon: "plus-minus",
              size: "16"
            })
          ]),
          _: 1
        }, 8, ["disabled"])) : c("", !0)
      ], 32)
    ], 2));
  }
});
export {
  Ot as default
};
//# sourceMappingURL=input-number.js.map
